// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"Text_paragraph__25X5D","gray":"Text_gray__rDE5i","editorError":"Text_editorError__2IOsk"};